import React from 'react';
import styled from 'styled-components';
import { WhisperSpinner } from 'react-spinners-kit';

const SpinnerContainer = styled.div`
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
`;

const Spinner = props => {
  return (
    <SpinnerContainer>
      <h1>{props.message}</h1>
      <WhisperSpinner size={60} frontColor="#57bdd9" backColor="#1c5f82" />
    </SpinnerContainer>
  );
};

export default Spinner;
